export const OrderStatus: { [key: string] : any }  = {
    waiting: "Получена",
    waiting_payment : "Получена",
    completed : "Завършена",
    cancelled : "Отказана",
    confirmed : "Потвърдена",
    dispatched : "Изпратена",
    delivered  : "Доставена",
    returned: "Върната"
}